import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PlainLoading from './PlainLoading';
import Container from '../Container';
import ContainerItem from '../ContainerItem';
import useTheme from '@material-ui/core/styles/useTheme';

interface Props {
  visible?: boolean;
  text?: string;
  spinnerColor?: string;
  textColor?: string;
}

const useStyles = makeStyles({
  loaderWrapper: {
    display: (props: Props): string => (props.visible ? 'inherit' : 'none'),
    background: 'rgba(0,0,0,0.5)',
    width: '100%',
    height: '100%',
    zIndex: 1110,
    top: 0,
    left: 0,
    position: 'fixed',
  },
  childWrapper: {
    width: '100%',
    zIndex: 0,
  },
});

const LoadingOverlay: React.FC<Props> = ({ text = 'Einen Moment bitte', spinnerColor, textColor, visible }) => {
  const classes = useStyles({ visible });
  const theme = useTheme();
  return (
    <Container>
      <ContainerItem className={classes.loaderWrapper}>
        <PlainLoading
          text={text}
          spinnerColor={spinnerColor ?? theme.palette.primary.main}
          textColor={textColor ?? theme.palette.primary.main}
        />
      </ContainerItem>
    </Container>
  );
};

export default LoadingOverlay;
